export enum DeviceTpye {
  PC = "PC",
  MOBILE = "MOBILE",
}
